export * from './src/automations-triggercatalog-v1-trigger-trigger-catalog.universal.js';
